import { Box, Typography } from '@mui/material';
import { bgColor, buttonBgColor, textColor } from '../../utils/themeColor';
import CustomButton from '../../components/CustomButton';
import { useNavigate, useLocation } from 'react-router-dom';
import useIsSmallMobile from '../../custom-hooks/useIsSmallMobile';
import { useEffect, useState } from 'react';

const FileDetails = () => {
  const isSmMobile = useIsSmallMobile();
  const navigate = useNavigate();
  const location = useLocation();

  const [showText, setShowText] = useState(false);
  const [fileData, setFileData] = useState({
    record_number: '',
    id: '',
    summary: '',
    transcription_text: '',
  });

  useEffect(() => {
    if (location.state) {
      const { record_number, id, summary, transcription_text } = location.state;
      setFileData({
        record_number: record_number || '',
        id: id || '',
        summary: summary || '',
        transcription_text: transcription_text || '',
      });
    } else {
      console.error('No transcription data received');
      navigate('/files');
    }
  }, [location, navigate]);

  const formatTranscription = (text: string) => {
    if (!text) return [];

    const lines = text.split(/\r?\n/).filter((line) => line.trim() !== '');

    const timestampPattern = /\[\d{2}:\d{2}:\d{2}\.\d{3} --> \d{2}:\d{2}:\d{2}\.\d{3}\]/;

    return lines
      .filter((line) => timestampPattern.test(line))
      .map((line, index) => {
        const timestampMatch = line.match(timestampPattern);
        const timestamp = timestampMatch ? timestampMatch[0] : '';
        const dialogue = line.replace(timestamp, '').trim();

        return { timestamp, dialogue, id: index };
      });
  };

  const formattedTranscription = formatTranscription(fileData.transcription_text);

  return (
    <>
      <Box
        sx={{
          width: '100%',
          maxWidth: '1200px',
          mx: { xs: 0, md: 'auto' },
        }}
      >
        <Box
          sx={{ my: { xs: 2.5, sm: 4.5 }, marginLeft: { xs: '17%', sm: 0 }, textAlign: 'center' }}
        >
          <CustomButton
            sx={{
              width: { xs: '75%', sm: '300px' },
              backgroundColor: buttonBgColor,
              color: '#fff',
              py: { xs: 1.8, sm: 1 },
              px: 2,
              borderRadius: '25px',
              fontWeight: 600,
              textTransform: 'capitalize',
              fontSize: { xs: '18px', sm: '20px' },
              lineHeight: '15px',
            }}
            onClick={() => navigate('/files')}
          >
            Back To Browser
          </CustomButton>
        </Box>
        <Box
          sx={{
            backgroundColor: bgColor,
            width: '90%',
            minHeight: '250px',
            borderTopRightRadius: '20px',
            borderBottomRightRadius: '20px',
            borderRadius: { xs: 'none', sm: '30px' },
            mx: { xs: 0, sm: 'auto' },
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Box sx={{ px: { xs: isSmMobile ? '10%' : '17%', sm: '100px' }, pb: { xs: 1, sm: 6 } }}>
            <Typography component="p" sx={{ fontSize: '13px' }}>
              ID: {fileData.id}
            </Typography>
            <Typography
              component="p"
              sx={{
                fontSize: '18px',
                fontWeight: 'bold',
                color: textColor,
              }}
            >
              Recording # {fileData.record_number}
            </Typography>
            <Typography component="p" sx={{ fontSize: '12px', lineHeight: '13px' }}>
              <span style={{ color: textColor, fontSize: '13px', fontWeight: 600 }}>Summary:</span>{' '}
              &ldquo;{fileData.summary}
              &rdquo;
            </Typography>
          </Box>
        </Box>
        {!showText ? (
          <Box
            sx={{ my: { xs: 2.5, sm: 4.5 }, marginLeft: { xs: '17%', sm: 0 }, textAlign: 'center' }}
          >
            <CustomButton
              sx={{
                width: { xs: '75%', sm: '300px' },
                backgroundColor: buttonBgColor,
                color: '#fff',
                py: { xs: 1.8, sm: 1 },
                px: 2,
                borderRadius: '25px',
                fontWeight: 600,
                textTransform: 'capitalize',
                fontSize: { xs: '18px', sm: '20px' },
                lineHeight: '15px',
              }}
              onClick={() => setShowText(true)}
            >
              Full Text
            </CustomButton>
          </Box>
        ) : (
          <Box
            sx={{
              backgroundColor: bgColor,
              width: '90%',
              minHeight: '250px',
              borderTopRightRadius: '20px',
              borderBottomRightRadius: '20px',
              borderRadius: { xs: 'none', sm: '30px' },
              mx: { xs: 0, sm: 'auto' },
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              my: { xs: 2.5, sm: 4.5 },
            }}
          >
            <Box
              sx={{
                px: { xs: isSmMobile ? '10%' : '17%', sm: '100px' },
                py: { xs: 2, sm: 3 },
                width: '100%',
              }}
            >
              <Typography
                component="p"
                sx={{ color: textColor, fontSize: '16px', fontWeight: 600, mb: 2 }}
              >
                Transcription Text:
              </Typography>

              <Box>
                {formattedTranscription.map((item) => (
                  <Box key={item.id} sx={{ mb: 2 }}>
                    <Typography component="p" sx={{ fontSize: '12px', color: 'gray', mb: 0.5 }}>
                      {item.timestamp}
                    </Typography>
                    <Typography component="p" sx={{ fontSize: '14px' }}>
                      {item.dialogue}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
};

export default FileDetails;
